import { render, staticRenderFns } from "./SecondaryNavigationMenuItemIcon.vue?vue&type=template&id=2c02ed49&scoped=true"
import script from "./SecondaryNavigationMenuItemIcon.vue?vue&type=script&lang=js"
export * from "./SecondaryNavigationMenuItemIcon.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNavigationMenuItemIcon.vue?vue&type=style&index=0&id=2c02ed49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02ed49",
  null
  
)

export default component.exports